@layer app {
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    container-type: inline-size;
    container-name: page;
  }
}
